import React, { useEffect, useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TableListing from "../common/tableListing";
import { masterServices } from "../../services/masterServices";
import { subRouteMapping } from "../../constant/subRoutes";
import routes from "../../routes";
import { Link, useLocation } from "react-router-dom";

const initialColumns = [
  { id: "productNumberPortal", label: "Service Number", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "productNumber", label: "(Service Number (SAP))", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "description", label: "Service Description", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "createdOnSap", label: "Created On", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" },
  { id: "createdBy", label: "Created By", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "materialGroup", label: "Material Group", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "col7", label: "SAC Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "uom", label: "Base Unit of Measure", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "col9", label: "Valuation Class", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  // { id: "col10", label: "Actions", isSort: true, sortLabel: "" },
];

const dummyFun = (param) => {  };

function MasterdataServices() {
  const location = useLocation();
  const [subRouteArr, setSubRouteArr] = useState([]);
  
  useEffect(() => {
    setSubRouteArr(subRouteMapping(routes, "MASTER_DATA"));
  }, []);
  
  return (
    <>    
     
     <div className="login-forms">
          <div className="text-centers">
            <div>
              <div className="search_filter_outerse ms-auto">
                <div className="search_mains">
                  <h5>Master Data</h5>
                </div>
              </div>
              
              <div className="heading_search_outer d sub-route-upper-sec">
              <div>
                <div className="sub-route-sec">
                  {subRouteArr?.map(
                    (ele, i) =>
                      ele.isSubRoute && (
                        <div
                          className={
                            location.pathname.indexOf(ele.path) !== -1
                              ? "sub-route-sec-div sub-route-sec-div-active"
                              : "sub-route-sec-div"
                          }
                        >
                          <Link to={ele.layout + ele.path}>{ele.name}</Link>
                          {/* <p>Existing Vendor</p> */}
                        </div>
                      )
                  )}
                </div>
              </div>
            </div>
            <TableListing
                column={initialColumns}
                listingArrName="products"
                filterKeyName="SERVICE_MASTER"
                componentName="SERVICE_MASTER"
                promiseRequest={masterServices?.getMasterListing}
                onFilterChange={dummyFun}
                promiseUrlType="LIST"
                additionalData={{
                  isMaster: true,
                  type: "Service",
                  isTrackOrder: false,
                  isFilter: true,
                  isSearch: true,
                  isPagePerSize: true,
                  isPagination: true,
                  isDragable: true,
                  isDownload: true,
                }}
                
              />
              
            </div>
          </div>
        </div>
    </>
  )
}

export default MasterdataServices